import { ListItemButton, ListItemButtonProps } from '@mui/material'
import React from 'react'

export type WcListItemButtonProps = ListItemButtonProps

export const WcListItemButton = ({children, ...props}: WcListItemButtonProps) => (
    <ListItemButton {...props}>
        {children}
    </ListItemButton>
  )